import DashboardShell from "../components/common/DashboardShell";

export default function OrganizerHome() {
  return (
    <DashboardShell>
      <div className="mx-auto max-w-3xl p-6">
        <h1 className="mb-2 text-2xl font-bold text-gray-800 dark:text-gray-100">
          Organizer Tools
        </h1>
        <p className="text-gray-500 dark:text-gray-400">
          Manage your chapter&rsquo;s teams, hackathons, and rosters. You are in
          organizer mode.
        </p>
      </div>
    </DashboardShell>
  );
}
